import axios from './axios';

export const submitAnswer = (answer) => axios.post('/api/AnswerReport/AddOrUpdateAnswers', answer);

export const fetchReportList = async (patientId) => {
  const formData = new FormData();
  formData.append('patientId', patientId);

  return axios.post('/api/AnswerReport/ReportList', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getAllPatientReports = (patientId) => axios.get(`/api/AnswerReport/HistoryReportList?patientId=${patientId}`);


// export const getReport = async (patientId) => {
//   console.log('Mock report called with:', patientId);

//   // Simulate network delay
//   await new Promise(resolve => setTimeout(resolve, 500));

//   return {
//     data: {
//       messages: [],
//       succeeded: true,
//       data: [
//         {
//           id: 1,
//           questionCode: "Q000",
//           staffName: null,
//           parentResponse: 2,
//           staffResponse: 2,
//           patientId: 1
//         },
//         {
//           id: 2,
//           questionCode: "Q000",
//           staffName: null,
//           parentResponse: 2,
//           staffResponse: 2,
//           patientId: 1
//         }
//       ],
//       exception: null,
//       code: 0
//     }
//   };
// };

// export const submitAnswer = async (answer) => {
//   console.log('Mock submitAnswer called with:', answer);

//   // Simulate network delay
//   await new Promise(resolve => setTimeout(resolve, 500));

//   return {
//     data: {
//       success: true,
//       message: "Answers submitted successfully.",
//       patientId: 1,
//       staffname: "Dr. Smith",
//       domain: {
//         categoryId: 1,
//         code: "RC",
//         id: 1,
//         name: "Receptive Language",
//         isDeleted: false
//       },
//       answers: [
//         {
//           id: 101,
//           questionId: 1,
//           staffResponse: 2,
//           parentResponse: 2,
//           createdBy: 12,
//           createdAt: "2025-07-23T13:10:00Z",
//           isDeleted: false
//         },
//         {
//           id: 102,
//           questionId: 2,
//           staffResponse: 3,
//           parentResponse: 1,
//           createdBy: 12,
//           createdAt: "2025-07-23T13:10:00Z",
//           isDeleted: false
//         }
//       ]
//     }
//   };
// };
